import React from 'react'
import PropTypes from 'prop-types'
import { mdiInformationOutline } from '@mdi/js'

import Text from '../../../../Components/Formik/Text'

const CoVTemperatureComponent = ({ translate, unitsOfMeasure, ...rest }) => {
  const { temperature } = unitsOfMeasure
  return (
    <>
      <Text
        name="reporting.value"
        label={translate('labels.covAcceptable')}
        accessoryText={`${temperature}° ${translate('labels.covLastKnown')}`}
        prefixText="+/-"
        textHelper={translate('labels.covTemperatureHelper')}
        hasTooltip
        tooltipIcon={mdiInformationOutline}
        tooltipContent={translate('labels.covRangeTooltip')}
        type="number"
        min="0"
        max="10"
        data-testid="cov-temperature-input"
        {...rest}
      />
    </>
  )
}

CoVTemperatureComponent.propTypes = {
  translate: PropTypes.func.isRequired,
  unitsOfMeasure: PropTypes.object.isRequired
}

export default CoVTemperatureComponent
